import React, { useEffect } from "react";

import { Page, List, Block, Link, Navbar, Popup, View, NavRight, Button, f7 } from "framework7-react";
import { getStoreOverallsStatuses } from "../../statuses/actions";
import { connect } from "react-redux";

import { Field, Form } from "react-final-form";
import { required, SmartSelect } from "modules/4_final_form/mobile";
import { moveStoreOveralls } from "../../actions";
import { getEmployees } from "modules/employees/actions";

function mapStateToProps(state) {
  return {
    employees: state.employees,
    store_overalls_statuses: state.store_overalls_statuses,
  };
}

let MovePopover = (props) => {
  const { opened, setOpened, selectedOveralls, store_overalls_statuses, setSelectedOveralls, employees } = props;

  useEffect(() => {
    props.getEmployees();
    props.getStoreOverallsStatuses();
  }, []);

  return (
    <Popup opened={opened} onPopupClosed={() => setOpened(false)} swipeToClose backdrop push>
      <View>
        <Page>
          <Navbar title="Move Overalls">
            <NavRight>
              <Link popupClose>Cancel</Link>
            </NavRight>
          </Navbar>

          <Block>
            {opened && (
              <Form
                initialValues={{ overalls: selectedOveralls }}
                render={(props) => {
                  const { handleSubmit } = props;
                  return (
                    <List>
                      <Field
                        component={SmartSelect}
                        name="employee_id"
                        options={_.map(employees, (emp) => {
                          return { value: emp.id, label: emp.display_name };
                        })}
                        label="Employee (optional)"
                        placeholder="Select Employee"
                        slot="list"
                        valueName="value"
                        labelName="label"
                        searchbar
                        searchbarPlaceholder="Search Employees"
                      />
                      <Field
                        component={SmartSelect}
                        name="status_id"
                        options={_.map(store_overalls_statuses, (emp) => {
                          return { value: emp.id, label: emp.name };
                        })}
                        label="Status"
                        placeholder="Select Status"
                        slot="list"
                        validate={required}
                        valueName="value"
                        labelName="label"
                      />
                      <Block slot="list">
                        <Button onClick={handleSubmit} fill>
                          Move {selectedOveralls.length} Overalls
                        </Button>
                      </Block>
                    </List>
                  );
                }}
                onSubmit={(values) => {
                  f7.dialog.preloader("Moving Overalls...");
                  props.moveStoreOveralls(values).then(() => {
                    f7.dialog.close();
                    f7.toast.show({ text: "Overalls Moved", closeTimeout: 2000 });
                    setSelectedOveralls([]);
                    setOpened(false);
                  });
                }}
              />
            )}
          </Block>
        </Page>
      </View>
    </Popup>
  );
};
export default connect(mapStateToProps, { getEmployees, getStoreOverallsStatuses, moveStoreOveralls })(MovePopover);
